import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { SearchModels } from 'app/models/search-filter.model';
import { WarnNotification } from 'app/models/warn-notification.model';
import { WarnReportNotification } from 'app/models/warn-report-notification.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class WarnNotificationsService {

    warnReportNotifications:BehaviorSubject<Array<WarnReportNotification>> 
    warnNotifications: any[];
    onChanged: BehaviorSubject<any>;
    public count=0;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
        this.warnReportNotifications = new BehaviorSubject([new WarnReportNotification])
    }

    getWarnNotifications(companyId: number, page?:number,page_size?:number,sort_active?:any,sort_direction?:any,searchList?:Array<SearchModels>): Promise<Array<WarnNotification>> {
        let params = new HttpParams()
        params = params.set("company_id", companyId.toString())
        if (page) {
          params = params.set("page", page.toString())
        }
        if (page_size) {
          params = params.set("page_size", page_size.toString())
        }
      if (sort_active && sort_direction) {
        params = params.set('sort_direction', sort_direction);
        params = params.set('sort_active', sort_active);
      }
      if (searchList && searchList.length != 0) {
        for (let j = 0; j < searchList.length!; j++) {
          params = params.set(`search_field[${j}]`, `${searchList[j].search_field}`)
          params = params.set(`search_value[${j}]`, searchList[j].search_value)
        }
      }
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "WarnNotifications",{params})
                .subscribe((response: any) => {
                    this.count = response.count;
                    this.warnNotifications = response.warnNotifications;
                    this.onChanged.next(this.warnNotifications);
                    resolve(response.warnNotifications);
                }, reject);
        });
    }

    getWarnReportNotifications(companyId: number): Promise<Array<WarnReportNotification>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "WarnNotifications/WarnReportNotification/" + companyId)
                .subscribe((response: any) => {
                    this.warnReportNotifications.next(response);
                    resolve(response);
                }, reject);
        });
    }
    
   clearWarnReportNotifications(companyId: number): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "WarnNotifications/WarnReportNotification/clear/" + companyId)
                .subscribe((response: any) => {
                    this.warnReportNotifications.next([]);
                    resolve(response);
                }, reject);
        });
    }
}
